var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "1080",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_c('span', [_vm._v(" 기본 설정 ")])]), _c('form-base', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('h5', {
    staticClass: "page-text--lg mt-24 mt-lg-48 mb-8 mb-lg-16 line-height-15"
  }, [_c('span', [_vm._v(" 기간 설정 ")])]), _c('form-time', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('h5', {
    staticClass: "page-text--lg mt-24 mt-lg-48 mb-8 mb-lg-16 line-height-15"
  }, [_c('span', [_vm._v(" 프로그램 상세 ")])]), _c('v-divider', {
    staticClass: "primary border-2 mb-10 mb-md-16"
  }), _c('naver-smarteditor', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('form-prev', {
    attrs: {
      "program": _vm.value
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 미리보기 ")])])];
      }
    }])
  }), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 취소 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.execText) + " ")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }